import {GUID} from "../../shared/models/GUID-interface";

export class BlockFilter{
    constructor(
        public param: string, public block: boolean
    ){

    }
}

export class BlockFilterGUID implements GUID{
    constructor(public GUID: string, public blockFilter: BlockFilter){

    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/block-filter.ts